module.exports = __webpack_public_path__ + "img/DE00642.053e8130.png";